import { Typography } from "@mui/material";
import { ThemeWrapper } from "@verity/components";
import { CoreSwitch } from "@verity/components/core";
import { useState } from "react";
import apiClient from "../../../../helpers/api-client";
import i18n from "../../../../i18n";
import { CustomSettingData } from "../../settings-page";

export function RequireMFAInput({
	loadData,
	setting,
	onSettingChange,
	disabled,
}: {
	loadData: { mfaRequired: boolean };
	setting: CustomSettingData<boolean>;
	onSettingChange: (value?: boolean) => void;
	disabled?: boolean;
}) {
	const [requireMFA, setRequireMFA] = useState(setting.value ?? loadData.mfaRequired);

	const updateSettings = (newRequireMFA: boolean) => {
		setRequireMFA(newRequireMFA);
		onSettingChange(newRequireMFA);
	};

	return (
		<ThemeWrapper>
			<div style={{ maxWidth: "100%", overflowX: "auto" }}>
				<div style={{ minWidth: "420px" }}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: "5px" }}>
						<div style={{ marginRight: "15px" }}>
							<Typography fontSize={14} lineHeight={1.6}>
								{i18n.t("portal.components.settings.requireMFA.description")}
							</Typography>
						</div>
						<div style={{ paddingTop: "8px", paddingBottom: "8px" }}>
							<CoreSwitch
								checked={requireMFA}
								onChange={(e) => updateSettings(e.target.checked)}
								disabled={disabled}
								labelTextType="left"
							/>
						</div>
					</div>
				</div>
			</div>
		</ThemeWrapper>
	);
}

export async function saveRequireMFA(instituteUuid?: string, requireMFA?: boolean) {
	try {
		if (instituteUuid) {
			if (typeof requireMFA === "boolean") {
				await apiClient.institute.setMfaRequired(instituteUuid, requireMFA);
			}
		} else {
			throw new Error("no instituteUuid");
		}
		return { ok: true };
	} catch (error) {
		console.error(error);
		return { ok: false, reason: "Failed to save require MFA setting." };
	}
}
